.body {
  height: 200px;
  padding: 15px;
}

.name {
  font-weight: 500;
  padding-top: 20px;
  font-size: 18px;
}

.loading {
  position: unset;
}
